import styled from 'styled-components';

export const StyledWrapper = styled.div`
	width: 100%;
`;
